import React, { useEffect } from "react";
import { Dialog, FormControlLabel, DialogTitle, DialogContent, DialogActions, Button, withStyles, FormGroup, Radio, RadioGroup, Checkbox, Typography } from '@material-ui/core';
import * as Yup from "yup";
import * as actions from '../store/colliTypeActions';
import * as productTypeActions from '../../../sc-admin/ProductType/store/productTypeActions';
import { snackActions } from '../../../sc-utilities/SnackBar';
import { hasPermission } from "../../../sc-utilities";
import { connect } from 'react-redux';
import SimplePresetForm from './SimplePresetForm';
import StandardPresetForm from './StandardPresetForm';
import ComplexPresetForm from './ComplexPresetForm';

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    buttonSafe: {
        '&:hover': {
            color: theme.palette.buttonText.default,
            backgroundColor: theme.palette.secondary.main,
        }
    },
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    formControl: {
        padding: theme.spacing(1),
        margin: theme.spacing(1),
        width: '90%'
    }
});


const ColliTypePresetForm = props => {
    const { classes, presetFormState, setPresetFormState, handleClosePresetSafe, handleClosePresetDanger, onGeneratePreset, activeCustomerID, translations, permissions, onListProductTypes } = props;

    let defaultValues = {
        simple: {
            PaletteName: "Palette",
            PaletteHeight: 144,
            PaletteWidth: 800,
            PaletteLength: 1200,
            PaletteMaxWeight: 1500,
            PaletteProductTypeIDs: []
        },
        standard: {
            StorageAreaName: "Storage Area",
            StorageAreaHeight: 100,
            StorageAreaWidth: 100,
            StorageAreaLength: 1200,
            StorageAreaMaxWeight: 1000,
            StorageAreaProductTypeIDs: [],
            PaletteName: "Palette",
            PaletteHeight: 144,
            PaletteWidth: 800,
            PaletteLength: 1200,
            PaletteMaxWeight: 1500,
            PaletteProductTypeIDs: []
        },
        complex: {
            StorageAreaName: "Storage Area",
            StorageAreaHeight: 100,
            StorageAreaWidth: 100,
            StorageAreaLength: 1200,
            StorageAreaMaxWeight: 1000,
            StorageAreaProductTypeIDs: [],
            ProcessingAreaName: "Processing Area",
            ProcessingAreaHeight: 100,
            ProcessingAreaWidth: 100,
            ProcessingAreaLength: 1200,
            ProcessingAreaMaxWeight: 1000,
            ProcessingAreaProductTypeIDs: [],
            PaletteName: "Palette",
            PaletteHeight: 144,
            PaletteWidth: 800,
            PaletteLength: 1200,
            PaletteMaxWeight: 1500,
            PaletteProductTypeIDs: [],
            BoxName: "Box",
            BoxHeight: 100,
            BoxWidth: 100,
            BoxLength: 100,
            BoxMaxWeight: 1000,
            BoxProductTypeIDs: []
        }
    };

    const handleCustom = () => {
        setPresetFormState({ ...presetFormState, custom: !presetFormState.custom });
    };

    const handleType = (_event, value) => {
        setPresetFormState({ ...presetFormState, type: value });
    };
    const fillProductTypeIDs = obj => {
        const keys = Object.keys(obj).filter(key => key.includes('ProductTypeIDs'));
        for (const key of keys) {
            obj[key] = extractProductTypes(presetFormState.productTypes);
        }
        return obj;
    };

    const formatProductTypes = obj => {
        const keys = Object.keys(obj).filter(key => key.includes('ProductTypeIDs'));
        for (const key of keys) {
            obj[key] = extractProductTypes(obj[key]);
        }
        return obj;
    }

    const defaultSubmitHandler = async () => {
        await onGeneratePreset({ ...presetFormState.warehouseObj, ActiveCustomerID: activeCustomerID, PresetType: presetFormState.type, ...fillProductTypeIDs(defaultValues[presetFormState.type]) });
        handleClosePresetDanger();
    };
    const customSubmitHandler = async data => {
        let requestData = { ...formatProductTypes(data), ...presetFormState.warehouseObj, ActiveCustomerID: activeCustomerID, PresetType: presetFormState.type, }
        await onGeneratePreset(requestData);
        handleClosePresetDanger();
    };

    useEffect(() => {
        const fetchData = async () => {
            let productTypes = await onListProductTypes({ ActiveCustomerID: activeCustomerID, listAll: true });
            if (productTypes instanceof Array && productTypes.length < 1) {
                snackActions.snackBarComponent("No product types found, please create at least one product types first.", "info");
            }

            setPresetFormState({ ...presetFormState, productTypes: productTypes });
        };
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const extractProductTypes = selectedProductTypes => {
        return selectedProductTypes.map(productType => productType.value);
    }


    let simpleInitialValues = {
        PaletteWidth: "",
        PaletteName: "",
        PaletteHeight: "",
        PaletteLength: "",
        PaletteMaxWeight: "",
        PaletteProductTypeIDs: []
    };
    let standardInitialValues = {
        StorageAreaWidth: "",
        StorageAreaName: "",
        StorageAreaHeight: "",
        StorageAreaLength: "",
        StorageAreaMaxWeight: "",
        StorageAreaProductTypeIDs: [],
        PaletteWidth: "",
        PaletteName: "",
        PaletteHeight: "",
        PaletteLength: "",
        PaletteMaxWeight: "",
        PaletteProductTypeIDs: []
    };
    let complexInitialValues = {
        StorageAreaWidth: "",
        StorageAreaName: "",
        StorageAreaHeight: "",
        StorageAreaLength: "",
        StorageAreaMaxWeight: "",
        StorageAreaProductTypeIDs: [],
        ProcessingAreaWidth: "",
        ProcessingAreaName: "",
        ProcessingAreaHeight: "",
        ProcessingAreaLength: "",
        ProcessingAreaMaxWeight: "",
        ProcessingAreaProductTypeIDs: [],
        PaletteWidth: "",
        PaletteName: "",
        PaletteHeight: "",
        PaletteLength: "",
        PaletteMaxWeight: "",
        PaletteProductTypeIDs: [],
        BoxWidth: "",
        BoxName: "",
        BoxHeight: "",
        BoxLength: "",
        BoxMaxWeight: "",
        BoxProductTypeIDs: []
    };
    let simpleFormSettings = {
        Validation: {
            PaletteName: Yup.string().required(),
        },
        FormTitle: translations["create_simple_preset"] || "Create simple preset",
        ButtonSubmit: hasPermission(permissions, 'colli_type_create') ? {
            Title: translations["save"] || "SAVE"
        } : null
    };

    let standardFormSettings = {
        Validation: {
            StorageAreaName: Yup.string().required(),
            PaletteName: Yup.string().required()
        },
        FormTitle: translations["create_standard_preset"] || "Create standard preset",
        ButtonSubmit: hasPermission(permissions, 'colli_type_create') ? {
            Title: translations["save"] || "SAVE"
        } : null
    };

    let complexFormSettings = {
        Validation: {
            StorageAreaName: Yup.string().required(),
            ProcessingAreaName: Yup.string().required(),
            PaletteName: Yup.string().required(),
            BoxName: Yup.string().required()
        },
        FormTitle: translations["create_complex_preset"] || "Create complex preset",
        ButtonSubmit: hasPermission(permissions, 'colli_type_create') ? {
            Title: translations["save"] || "SAVE"
        } : null
    };

    return (
        <Dialog open={presetFormState.open}
            onClose={handleClosePresetSafe}
            aria-labelledby="form-dialog-title"
            onBackdropClick={handleClosePresetSafe}
            disableBackdropClick={false}
            disableEscapeKeyDown={false}
            fullWidth={true}>
            <DialogTitle id="form-dialog-title">{translations["create_colli_type_preset"] || "Create preset colli types"}</DialogTitle>
            <DialogContent>
                <FormGroup >
                    <RadioGroup row aria-label="type" name="type" value={presetFormState.type || 'simple'} onChange={handleType}>
                        <FormControlLabel value="simple" control={<Radio />} label={translations['simple'] || "Simple"} />
                        <FormControlLabel value="standard" control={<Radio />} label={translations['standard'] || "Standard"} />
                        <FormControlLabel value="complex" control={<Radio />} label={translations['complex'] || "Complex"} />
                    </RadioGroup>
                    {presetFormState.type === 'simple' ? <Typography variant='caption'>{translations['simple_palette_description'] || 'A palette, containing any products'}</Typography> : null}
                    {presetFormState.type === 'standard' ?
                        <>
                            <Typography variant='caption'>{translations['storage_area_description'] || 'Storage area (Holder)'}</Typography>
                            <Typography variant='caption'>{translations['standard_palette_description'] || 'Palette (Possible holders: Storage area) - may hold products'}</Typography>
                        </>
                        : null}
                    {presetFormState.type === 'complex' ?
                        <>
                            <Typography variant='caption'>{translations['storage_area_description'] || 'Storage area (Holder)'}</Typography>
                            <Typography variant='caption'>{translations['processing_area_description'] || 'Processing area (Holder) - may hold products'}</Typography>
                            <Typography variant='caption'>{translations['palette_description'] || 'Palette (Possible holders: Storage area, Processing area) - may hold products'}</Typography>
                            <Typography variant='caption'>{translations['box_description'] || 'Box (Possible holders: Palette) - may hold products'}</Typography>
                        </>
                        : null}
                    <div>
                        <FormControlLabel
                            control={<Checkbox checked={presetFormState.custom} name="custom" onChange={handleCustom} color="primary" disabled={!presetFormState.type} />}
                            labelPlacement="end" label={translations['custom'] || 'Custom'}
                        />
                    </div>
                    {
                        presetFormState.custom ?
                            <div>
                                {
                                    presetFormState.type === 'simple' ?
                                        <SimplePresetForm
                                            formSettings={simpleFormSettings}
                                            initialValues={simpleInitialValues}
                                            handleSubmit={customSubmitHandler}
                                            productTypes={presetFormState.productTypes}
                                            translations={translations}
                                        ></SimplePresetForm> : null
                                }
                                {
                                    presetFormState.type === 'standard' ?
                                        <StandardPresetForm
                                            formSettings={standardFormSettings}
                                            initialValues={standardInitialValues}
                                            handleSubmit={customSubmitHandler}
                                            productTypes={presetFormState.productTypes}
                                            translations={translations}
                                        ></StandardPresetForm> : null
                                }
                                {
                                    presetFormState.type === 'complex' ?
                                        <ComplexPresetForm
                                            formSettings={complexFormSettings}
                                            initialValues={complexInitialValues}
                                            handleSubmit={customSubmitHandler}
                                            productTypes={presetFormState.productTypes}
                                            translations={translations}
                                        ></ComplexPresetForm> : null
                                }
                            </div>
                            : null
                    }
                </FormGroup>
            </DialogContent>
            { !presetFormState.custom ?
                <DialogActions>
                    <Button onClick={defaultSubmitHandler} variant="contained" className={classes.buttonDanger}>
                        {translations['save'] || 'Save'}
                    </Button>
                </DialogActions> : null
            }
        </Dialog>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        userSettings: state.core.login.user.userSetting,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onGeneratePreset: params => dispatch(actions.generatePreset(params)),
        onListProductTypes: (data) => dispatch(productTypeActions.listProductTypes(data))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ColliTypePresetForm));